import { render, staticRenderFns } from "./HotelsList.vue?vue&type=template&id=5c86d125&"
import script from "./HotelsList.vue?vue&type=script&lang=js&"
export * from "./HotelsList.vue?vue&type=script&lang=js&"
import style0 from "./HotelsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports